import L from 'leaflet';

/**
 * Returns a callback to initialize the map and location.
 * @param {Element} component
 * @returns {Function}
 */
const handleInit = (component) => () => {
    const iconUrl = $(component).attr('data-marker-icon');
    const icon = L.icon({
        iconUrl,
        iconSize: [32, 44],
        iconAnchor: [16, 22],
        popupAnchor: [16, -5],
    });
    const lat = Number($(component).attr('data-location-lat'));
    const lng = Number($(component).attr('data-location-lng'));
    const offset = Number($(component).attr('data-marker-offset')) || 50;
    const location = [lat, lng];
    const mapElement = $('<div data-map>').prependTo(component).get(0);

    // instantiate map
    const map = L.map(mapElement)
        .setView(location, 12)
        // pan map down a bit to prevent marker from being overlapped by info overlay
        .panBy([0, offset]);
    // set location marker
    L.marker(location, { icon }).addTo(map);
    // add tile layer
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        minZoom: 5,
        maxZoom: 18,
    }).addTo(map);

    // store map and location on component
    $(component).data('map', map);
    $(component).data('location', location);
};

export default handleInit;



// WEBPACK FOOTER //
// ./src/scripts/components/map/handleInit.js